import * as Ticketure from '@/types/ticketure-api.types'
import {
  TICKETURE_ADD_ON_EVENT_CATEGORY,
  TICKETURE_EXTERNAL_MUSIC_EVENT_CATEGORY,
} from '@/config/ticketure-event-data.config'

/**
 * Convert category string to a typed EventCategory,
 * if the category is not found, return the category as is
 * @param {Ticketure.EventCategory} category incoming category string
 * @returns {Transformed.EventCategory} typed EventCategory
 */
export const transformEventCategory = (category: Ticketure.EventCategory): Transformed.EventCategory => {
  const lowerCategory = category.toLowerCase()

  if (lowerCategory === TICKETURE_ADD_ON_EVENT_CATEGORY.toLowerCase()) {
    return 'AddOn'
  }

  if (lowerCategory === TICKETURE_EXTERNAL_MUSIC_EVENT_CATEGORY.toLowerCase()) {
    return 'Music'
  }

  // Not the best, but will do for now
  return category as Transformed.EventCategory
}
